import { render, staticRenderFns } from "./NewSupplierUsers.vue?vue&type=template&id=97c867a4&scoped=true&"
import script from "./NewSupplierUsers.vue?vue&type=script&lang=js&"
export * from "./NewSupplierUsers.vue?vue&type=script&lang=js&"
import style0 from "./NewSupplierUsers.vue?vue&type=style&index=0&id=97c867a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c867a4",
  null
  
)

export default component.exports